// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("./hand-symbol.svg", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"flex-center popup-idle-container\">\n  <div class=\"flex-center popup-idle\">\n    <img class=\"hand-symbol\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" />\n    <div id=\"popup-idle-counter\"></div>\n  </div>\n</div>\n";
// Exports
export default code;